// Ducha Vital — guion propio (prefijo mt-). Vanilla JS, sin librerías externas.
(function () {
  "use strict";

  function initReveal() {
    var items = document.querySelectorAll(".mt-reveal");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute("data-mt-delay") || "0", 10);
            setTimeout(function () { el.classList.add("mt-visible"); }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    items.forEach(function (el, i) {
      if (!el.hasAttribute("data-mt-delay")) {
        el.setAttribute("data-mt-delay", String((i % 6) * 80));
      }
      observer.observe(el);
    });
  }

  function initGalerias() {
    document.querySelectorAll("[data-mt-galeria]").forEach(function (galeria) {
      var main = galeria.querySelector("[data-mt-galeria-main]");
      var thumbs = galeria.querySelectorAll("[data-mt-galeria-thumb]");
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var url = thumb.getAttribute("data-mt-full");
          var alt = thumb.getAttribute("data-mt-alt") || "";
          if (!url) return;
          main.src = url;
          main.alt = alt;
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  function initCarruseles() {
    document.querySelectorAll("[data-mt-carousel]").forEach(function (carousel) {
      var track = carousel.querySelector("[data-mt-carousel-track]");
      var prev = carousel.querySelector("[data-mt-carousel-prev]");
      var next = carousel.querySelector("[data-mt-carousel-next]");
      if (!track || !prev || !next) return;
      var originals = Array.prototype.slice.call(track.children);
      if (originals.length < 2) return;

      // Bucle infinito: copias antes y después; al salir del bloque central se salta sin animación a la tarjeta equivalente.
      function copia(card) {
        var c = card.cloneNode(true);
        Array.prototype.slice.call(c.attributes).forEach(function (a) {
          if (a.name.indexOf("data-shopify") === 0) c.removeAttribute(a.name);
        });
        c.setAttribute("aria-hidden", "true");
        return c;
      }
      function paso() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return originals[0].getBoundingClientRect().width + gap;
      }
      function periodo() { return originals.length * paso(); }
      // Con pocas reseñas hacen falta varias copias por lado para cubrir toda la pantalla.
      var juegos = Math.ceil(Math.max(screen.width, window.innerWidth) / periodo());
      for (var j = 0; j < juegos; j++) {
        var antes = document.createDocumentFragment();
        originals.forEach(function (card) { antes.appendChild(copia(card)); });
        track.insertBefore(antes, track.firstElementChild);
        originals.forEach(function (card) { track.appendChild(copia(card)); });
      }

      function inicio() { return originals[0].offsetLeft - track.firstElementChild.offsetLeft; }
      function recolocar() {
        var p = periodo();
        var destino = inicio() + ((((track.scrollLeft - inicio()) % p) + p) % p);
        if (Math.abs(destino - track.scrollLeft) > 1) track.scrollTo({ left: destino, behavior: "instant" });
      }

      track.scrollTo({ left: inicio(), behavior: "instant" });
      prev.addEventListener("click", function () { track.scrollBy({ left: -paso(), behavior: "smooth" }); });
      next.addEventListener("click", function () { track.scrollBy({ left: paso(), behavior: "smooth" }); });
      var espera;
      track.addEventListener("scroll", function () {
        clearTimeout(espera);
        espera = setTimeout(recolocar, 150);
      }, { passive: true });
      window.addEventListener("resize", recolocar);
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    if (!format) return value + " €";
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/i, value);
  }

  function initProducto() {
    var root = document.querySelector("[data-mt-producto]");
    if (!root) return;

    var moneyFormat = root.getAttribute("data-mt-money-format") || "{{amount}} €";
    var variantsJson = root.querySelector("[data-mt-variants]");
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

    var idInput = root.querySelector("[data-mt-variant-id]");
    var priceNow = root.querySelector("[data-mt-price-now]");
    var priceWas = root.querySelector("[data-mt-price-was]");
    var addBtn = root.querySelector("[data-mt-add]");
    var stockMsg = root.querySelector("[data-mt-stock]");
    var qtyInput = root.querySelector("[data-mt-qty-input]");
    var pillGroups = root.querySelectorAll("[data-mt-option-group]");
    var packs = root.querySelectorAll("[data-mt-pack]");

    // Packs de cantidad: mismo cálculo que en Liquid y que el carrito de Shopify (descuento redondeado hacia abajo al céntimo).
    function preciosPacks(variant) {
      packs.forEach(function (pack) {
        var qty = parseInt(pack.getAttribute("data-mt-pack-qty"), 10) || 1;
        var desc = parseInt(pack.getAttribute("data-mt-pack-desc"), 10) || 0;
        var base = variant.price * qty;
        var total = base - Math.floor((base * desc) / 100);
        var poner = function (selector, cents) {
          var el = pack.querySelector(selector);
          if (el) el.textContent = formatMoney(cents, moneyFormat);
        };
        poner("[data-mt-pack-price]", total);
        poner("[data-mt-pack-was]", base);
        poner("[data-mt-pack-unit]", Math.floor(total / qty));
        poner("[data-mt-pack-save]", base - total);
      });
    }

    function elegirPack(elegido) {
      packs.forEach(function (pack) {
        var activo = pack === elegido;
        pack.classList.toggle("is-selected", activo);
        var radio = pack.querySelector(".mt-pack-radio");
        if (radio) radio.checked = activo;
      });
      if (qtyInput) qtyInput.value = elegido.getAttribute("data-mt-pack-qty") || "1";
    }

    packs.forEach(function (pack) {
      var radio = pack.querySelector(".mt-pack-radio");
      if (radio) radio.addEventListener("change", function () { elegirPack(pack); });
    });

    function currentSelection() {
      var sel = [];
      pillGroups.forEach(function (group) {
        var active = group.querySelector(".mt-pill.is-selected");
        sel.push(active ? active.getAttribute("data-mt-value") : null);
      });
      return sel;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    function updateAvailability() {
      var selection = currentSelection();
      pillGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll(".mt-pill").forEach(function (pill) {
          var testSelection = selection.slice();
          testSelection[groupIndex] = pill.getAttribute("data-mt-value");
          var possible = variants.some(function (v) {
            return v.options.every(function (opt, i) {
              return testSelection[i] == null || opt === testSelection[i];
            });
          });
          pill.disabled = !possible;
        });
      });
    }

    function render() {
      var selection = currentSelection();
      var variant = findVariant(selection);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price, moneyFormat);
      if (packs.length) preciosPacks(variant);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          priceWas.style.display = "";
        } else {
          priceWas.style.display = "none";
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.querySelector("[data-mt-add-label]") &&
          (addBtn.querySelector("[data-mt-add-label]").textContent = variant.available
            ? addBtn.getAttribute("data-mt-label-disponible")
            : addBtn.getAttribute("data-mt-label-agotado"));
      }
      if (stockMsg) {
        var urgencia = stockMsg.getAttribute("data-mt-msg-urgencia") || "";
        if (variant.available) {
          if (urgencia) {
            stockMsg.innerHTML = '<span class="mt-urgency-dot" aria-hidden="true"></span>' + urgencia;
            stockMsg.style.display = "";
          } else {
            stockMsg.style.display = "none";
          }
        } else {
          stockMsg.textContent = stockMsg.getAttribute("data-mt-msg-agotado");
          stockMsg.style.display = "";
        }
        stockMsg.classList.toggle("is-available", variant.available);
        stockMsg.classList.toggle("is-unavailable", !variant.available);
      }
      {
        var galeria = root.querySelector("[data-mt-galeria]");
        var main = galeria && galeria.querySelector("[data-mt-galeria-main]");
        if (main) {
          var targetSrc = variant.featured_image || galeria.getAttribute("data-mt-default-image");
          var targetAlt = variant.featured_image ? null : galeria.getAttribute("data-mt-default-alt");
          if (targetSrc) {
            main.src = targetSrc;
            var thumbs = galeria.querySelectorAll("[data-mt-galeria-thumb]");
            var matched = false;
            thumbs.forEach(function (t) {
              var isMatch = t.getAttribute("data-mt-full") === targetSrc;
              t.classList.toggle("is-active", isMatch);
              if (isMatch) { main.alt = t.getAttribute("data-mt-alt") || main.alt; matched = true; }
            });
            if (!matched && targetAlt) main.alt = targetAlt;
          }
        }
      }
      updateAvailability();
    }

    pillGroups.forEach(function (group) {
      group.querySelectorAll(".mt-pill").forEach(function (pill) {
        pill.addEventListener("click", function () {
          if (pill.disabled) return;
          group.querySelectorAll(".mt-pill").forEach(function (p) { p.classList.remove("is-selected"); });
          pill.classList.add("is-selected");
          render();
        });
      });
    });

    if (qtyInput) {
      root.querySelectorAll("[data-mt-qty-minus]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
      });
      root.querySelectorAll("[data-mt-qty-plus]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      });
    }

    render();
  }

  function initComparadores() {
    document.querySelectorAll("[data-mt-comparador]").forEach(function (el) {
      var dragging = false;

      function setPos(clientX) {
        var rect = el.getBoundingClientRect();
        var x = (clientX - rect.left) / rect.width;
        x = Math.max(0, Math.min(1, x));
        el.style.setProperty("--mt-pos", x * 100 + "%");
      }

      el.addEventListener("pointerdown", function (e) {
        dragging = true;
        el.setPointerCapture(e.pointerId);
        setPos(e.clientX);
      });
      el.addEventListener("pointermove", function (e) {
        if (dragging) setPos(e.clientX);
      });
      el.addEventListener("pointerup", function () { dragging = false; });
      el.addEventListener("pointercancel", function () { dragging = false; });
    });
  }

  // Enlaces a otra sección de la misma página (p. ej. "Ver más productos"): se ocultan si esa sección no existe
  function initEnlacesSeccion() {
    document.querySelectorAll("[data-mt-enlace-seccion]").forEach(function (a) {
      var id = (a.getAttribute("href") || "").replace("#", "");
      var destino = id && document.getElementById(id);
      if (!destino) { a.hidden = true; return; }
      // Desplazamiento suave y, si en 1 s no ha llegado (navegadores que no animan), salto directo
      a.addEventListener("click", function (e) {
        e.preventDefault();
        destino.scrollIntoView({ behavior: "smooth", block: "start" });
        if (history.replaceState) history.replaceState(null, "", "#" + id);
        setTimeout(function () {
          if (Math.abs(destino.getBoundingClientRect().top) > 120) destino.scrollIntoView({ block: "start" });
        }, 1000);
      });
    });
  }

  // ---------- Carrito lateral propio (sustituye a Sternify) ----------
  // Añade al carrito por AJAX y vuelve a pintar el carrito lateral de Dawn (snippets/cart-drawer.liquid).
  function carritoLateral() {
    var drawer = document.querySelector("cart-drawer");
    return drawer && typeof drawer.renderContents === "function" ? drawer : null;
  }

  function seccionesCarrito() {
    return ["cart-drawer", "cart-icon-bubble"];
  }

  function pintarCarrito(drawer, respuesta, origen) {
    if (drawer.classList.contains("is-empty")) drawer.classList.remove("is-empty");
    drawer.renderContents(respuesta);
    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: origen, cartData: respuesta });
    }
  }

  function initCarrito() {
    // 1) Formulario de compra de las páginas de producto MT
    document.querySelectorAll("[data-mt-producto] form[action*=\"/cart/add\"]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        var drawer = carritoLateral();
        if (!drawer || !window.fetch || !window.FormData) return; // sin carrito lateral: envío normal
        e.preventDefault();
        var boton = form.querySelector("[type=submit]");
        var aviso = form.querySelector("[data-mt-add-error]");
        if (aviso) aviso.remove();
        if (boton) { boton.setAttribute("aria-busy", "true"); boton.disabled = true; }

        var datos = new FormData(form);
        datos.append("sections", seccionesCarrito().join(","));
        datos.append("sections_url", window.location.pathname);

        fetch((window.routes && routes.cart_add_url) || "/cart/add", {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
          body: datos
        })
          .then(function (r) { return r.json(); })
          .then(function (respuesta) {
            if (respuesta.status) {
              var p = document.createElement("p");
              p.className = "mt-add-error";
              p.setAttribute("data-mt-add-error", "");
              p.setAttribute("role", "alert");
              p.textContent = respuesta.description || respuesta.message || "No se ha podido añadir al carrito.";
              if (boton) boton.insertAdjacentElement("afterend", p);
              return;
            }
            pintarCarrito(drawer, respuesta, "mt-producto");
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (boton) { boton.removeAttribute("aria-busy"); boton.disabled = false; }
          });
      });
    });

    // 2) Botón "Añadir" de los productos recomendados dentro del carrito
    document.addEventListener("click", function (e) {
      var boton = e.target.closest("[data-mt-cd-anadir]");
      if (!boton) return;
      var drawer = carritoLateral();
      if (!drawer) return;
      e.preventDefault();
      var tarjeta = boton.closest(".mt-cd-rec");
      var selector = tarjeta && tarjeta.querySelector("[data-mt-cd-variante]");
      var id = selector ? selector.value : boton.getAttribute("data-variant-id");
      boton.setAttribute("aria-busy", "true");
      fetch(((window.routes && routes.cart_add_url) || "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: seccionesCarrito(),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (respuesta) {
          if (respuesta.status) {
            var errores = document.getElementById("CartDrawer-CartErrors");
            if (errores) errores.textContent = respuesta.description || "No se ha podido añadir al carrito.";
            boton.removeAttribute("aria-busy");
            return;
          }
          pintarCarrito(drawer, respuesta, "mt-recomendados");
        })
        .catch(function () { boton.removeAttribute("aria-busy"); });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initEnlacesSeccion();
    initCarrito();
    initGalerias();
    initCarruseles();
    initProducto();
    initComparadores();
  });
})();
